import { useState } from 'react';
import './CardsBlock.css';
import picsIcon from '../assets/pics.svg';
import pics1Icon from '../assets/pics (1).svg';
import pics2Icon from '../assets/pics (2).svg';
import defaultImage from '../assets/default.png';
import hoverImage from '../assets/hover.png';

const CardsBlock = () => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div className="cards-block" id="section-features">
      <div 
        className="cards-block__card"
        onMouseEnter={() => setHoveredCard(0)}
        onMouseLeave={() => setHoveredCard(null)}
      >
        <img src={picsIcon} alt="Join" className="cards-block__icon" />
        <h3 className="cards-block__title">JOIN</h3>
        <p className="cards-block__text">Join WinningPartner Network today and start earning today.</p>
        <img src={hoveredCard === 0 ? hoverImage : defaultImage} alt="" className="cards-block__overlay" />
      </div>
      <div 
        className="cards-block__card"
        onMouseEnter={() => setHoveredCard(1)}
        onMouseLeave={() => setHoveredCard(null)}
      >
        <img src={pics1Icon} alt="Promote" className="cards-block__icon" />
        <h3 className="cards-block__title">PROMOTE</h3>
        <p className="cards-block__text">Get immediate access to a range of marketing materials.</p>
        <img src={hoveredCard === 1 ? hoverImage : defaultImage} alt="" className="cards-block__overlay" />
      </div>
      <div 
        className="cards-block__card"
        onMouseEnter={() => setHoveredCard(2)}
        onMouseLeave={() => setHoveredCard(null)}
      >
        <img src={pics2Icon} alt="Earn" className="cards-block__icon" />
        <h3 className="cards-block__title">EARN</h3>
        <p className="cards-block__text">Watch your traffic turn into cash.</p>
        <img src={hoveredCard === 2 ? hoverImage : defaultImage} alt="" className="cards-block__overlay" />
      </div>
    </div>
  );
};

export default CardsBlock;
